import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

interface NarrativeOnItDialogProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

export function NarrativeOnItDialog({ onOpenChange, open }: NarrativeOnItDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent className="border-border-subtle bg-popover w-[320px] max-w-[calc(100vw-32px)] gap-0 rounded-lg border p-0 shadow-lg">
        <DialogHeader className="px-4 pt-4 text-left">
          <DialogTitle className="text-foreground font-[Inter] text-[12px] leading-[170%] font-semibold tracking-[0%]">
            {t('narrative.onIt.title')}
          </DialogTitle>
        </DialogHeader>
        <p className="text-foreground px-4 pt-1 text-left font-[Inter] text-[12px] leading-[170%] font-normal tracking-[0%]">
          {t('narrative.onIt.description')}
        </p>
        <div className="px-4 pt-3 pb-3">
          <Button
            className="bg-primary-active text-primary-foreground h-7 w-full gap-1 rounded-md px-3 font-[Inter] text-[12px] leading-[170%] font-semibold hover:opacity-90"
            onClick={() => onOpenChange(false)}
            type="button"
          >
            {t('narrative.onIt.done')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
